import { useRef, useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Col, Container, Row} from 'react-bootstrap';
import axios from '../api/axios';
import useNasaApod from '../hooks/useNasaApod';
import ApodMedia from './ApodMedia';
import { format } from 'date-fns';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../index.css';
const LOGIN_URL = '/auth';
const Login = () => {

    const { setAuth, setPersist } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [showPwd, setShowPwd] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.post(LOGIN_URL,
                JSON.stringify({ user, pwd }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            const accessToken = response?.data?.accessToken;
            const roles = response?.data?.roles;
            const username = response?.data?.user || user;
            setPersist(true);
            setAuth({
                user: username,
                roles,
                accessToken,
                plan: response?.data?.plan,
                subscriptionStatus: response?.data?.subscriptionStatus,
                limits: response?.data?.limits,
            });
            setUser('');
            setPwd('');
            
            navigate(from, { replace: true });
        } catch (err) {
            if (!err?.response) {
                setErrMsg('No server response. Try again in a moment.');
            } else if (err.response?.status === 400) {
                setErrMsg('Enter your username/email and password.');
            } else if (err.response?.status === 401) {
                setErrMsg(err.response?.data?.message || 'Wrong username or password.');
            } else if (err.response?.status === 429) {
                setErrMsg('Too many sign-in attempts. Please wait a few minutes.');
            } else {
                setErrMsg('Sign in failed. Try again.');
            }
            errRef.current.focus();
        } finally {
            setIsSubmitting(false);
        }
    }

    const { apod, loading: apodLoading, error: apodError } = useNasaApod();

    const welcoming ="Welcome to Recipe Lab! We love food and believe in its value in every day life. Custom recipe shared digital recipe book!   ";
 
    const dateTime = `${format(new Date(), 'EEEE')}`;
    

return (
<div id="btn"  className="App">
<h1 className='title'>RECIPE LAB</h1>

        <section >
        <Container><Col><Row>
            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            
            <p className='ParagraphA'>{welcoming}</p>
            </Row></Col>
            </Container>
            <h1 className="heading">Sign In</h1>
            <span className="heading">{dateTime}</span>
            <form onSubmit={handleSubmit} className="login-form">
                <label htmlFor="username">Username or email</label>
                <input
                    type="text"
                    id="username"
                    ref={userRef}
                    autoComplete="username"
                    onChange={(e) => setUser(e.target.value)}
                    value={user}
                    required
                />
                <label htmlFor="password">Password</label>
                <div className="password-field">
                  <input
                      type={showPwd ? 'text' : 'password'}
                      id="password"
                      autoComplete="current-password"
                      onChange={(e) => setPwd(e.target.value)}
                      value={pwd}
                      required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPwd((prev) => !prev)}
                    aria-label={showPwd ? 'Hide password' : 'Show password'}
                  >
                    <i className={`bi ${showPwd ? 'bi-eye-slash' : 'bi-eye'}`} />
                  </button>
                </div>
                <button type="submit" className="login-submit-btn" disabled={isSubmitting}>
                  <i className="bi bi-box-arrow-in-right" aria-hidden="true" />
                  {isSubmitting ? 'Signing in...' : 'Sign In'}
                </button>
            </form>

            <div className="login-actions">
              <Link to="/forgot-password" className="login-action-btn login-action-btn--ghost">
                <i className="bi bi-key" aria-hidden="true" />
                Forgot password?
              </Link>
              <Link to="/register" className="login-action-btn login-action-btn--accent">
                <i className="bi bi-person-plus" aria-hidden="true" />
                Sign Up
              </Link>
            </div>
            <p className="login-actions-hint">New here? Create a free account to start your recipe book.</p>
        </section>
            
        <div >

{apodLoading ? (
  <h1>loading...</h1>
) : apodError ? (
  <p className="Paragraph">{apodError}</p>
) : apod ? (
  <div>
    <Container>
      <Row className="row">
        <Col className='Col'>
          <h1 className='titlenasa'>{apod.title}</h1>
          <ApodMedia
            url={apod.url}
            embedUrl={apod.embedUrl}
            mediaType={apod.mediaType}
            title={apod.title}
            classPrefix="login-apod"
          />
        </Col>
        <Col className='Col'>
          <h2 className='heading'>Facts from NASA</h2>
          <p className='Paragraph'>{apod.explanation}</p>
        </Col>
      </Row>
    </Container>
  </div>
) : null}
</div>
</div>
    )
}

export default Login
